<!-- #region First -->
<section [ngClass]="lang" class="first pt-5 mb-5">
  <div class="container">
    <div class="row">
      <div class="col-md-5 col-sm-12 p5wow fadeInLeft">
        <img src="./assets/images/slider/dream-come-true.svg" alt="Logo" class="logo" (load)="onLoading('dream')">
        <div id="dream" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div class="col-md-6 col-sm-12 m-auto wow fadeInRight">

        <h2 *ngIf="lang=='en'" class="text-center">
          Who we are...?
        </h2>
        <h2 *ngIf="lang == 'ar'" class="text-center">
          من نحن...؟
        </h2>

        <!-- <P *ngIf="lang == 'en'" class="p-3">
          Search....!
        </P>
        <P *ngIf="lang == 'ar'" class="p-3">
          جاري البحث....!
        </P> -->
      </div>
    </div>
  </div>
</section>
<!-- #endregion -->

<!-- #region Info -->
<section [ngClass]="lang" class="info pt-5">
  <div class="container">
    <div class="row">
      <div class="col-md-7 col-sm-12">
        <div class="row">
          <!-- #region About company -->
          <article [ngClass]="lang" id="company" class="item col-12 wow fadeInUp" data-wow-delay="0.15s">
            <aside class="col-3">
              <img src="../../../../assets/images/Services/Consulting.svg" alt="About us" (load)="onLoading('Consulting1')">
              <div id="Consulting1" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </aside>

            <aside class="col-12">
              <h3 *ngIf="lang == 'en'" class="col-12">About us</h3>
              <h3 *ngIf="lang == 'ar'" class="col-12">نبذة</h3>

              <section class="text-justify">
                <p *ngIf="lang == 'en'">
                  Company Ltd. has been established in Riyadh, Saudi Arabia since 2001. Our vision has been to be a leading
                  company
                  providing innovative technology solutions for businesses in the Kingdom of Saudi Arabia and countries
                  with
                  developing and stable economies in the region. During our years of success and rapid growth, our
                  company has
                  established several regional offices. The company was established in 2017.
                </p>
                <p *ngIf="lang == 'ar'">
                  تاسست شركة الشركة المحدودة في مدينة الرياض بالمملكة العربية السعودية منذ العام 2001، لقد كانت رؤيتنا منذ
                  البدء ان
                  نكون شركة رائدة تقدم حلول تقنية مبتكرة للاعمال في المملكة و البلدان ذات الاقتصادات النامية والمستقرة
                  في
                  المنطقة. خلال سنوات النجاح الذي حققناه والنمو المتسارع , اسست الشركة عدة مكاتب اقليمية وتم تاسيس شركة
                  الشركة
                  السودان ف العام 2017 .
                </p>
              </section>
            </aside>
          </article>
          <!-- #endregion -->


          <!-- #region About Responsiveness -->
          <article [ngClass]="lang" id="Responsiveness" class="item col-12 wow fadeInUp" data-wow-delay="0.15s">
            <aside class="col-3">
              <img src="../../../../assets/images/Services/Consulting.svg" alt="Responsiveness" (load)="onLoading('Consulting2')">
              <div id="Consulting2" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </aside>

            <aside class="col-12">
              <h3 *ngIf="lang == 'en'" class="col-12">Responsiveness</h3>
              <h3 *ngIf="lang == 'ar'" class="col-12">الإستجابة</h3>

              <section class="text-justify">
                <p *ngIf="lang == 'en'">
                  We listen to our customers and respond to their needs.
                </p>
                <p *ngIf="lang == 'ar'">
                  نستمع لعملائنا بعناية ونستجيب لاحتياجاتهم.
                </p>
              </section>
            </aside>
          </article>
          <!-- #endregion -->

          <!-- #region About Integrity  -->
          <article [ngClass]="lang" id="Integrity" class="item col-12 wow fadeInUp" data-wow-delay="0.15s">
            <aside class="col-3">
              <img src="../../../../assets/images/Services/Consulting.svg" alt="Integrity" (load)="onLoading('Consulting3')">
              <div id="Consulting3" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </aside>

            <aside class="col-12">
              <h3 *ngIf="lang == 'en'" class="col-12">Integrity</h3>
              <h3 *ngIf="lang == 'ar'" class="col-12">النزاهة</h3>

              <section class="text-justify">
                <p *ngIf="lang == 'en'">
                  We are honest, open and work within the spirit and letter of
                  the law.
                </p>
                <p *ngIf="lang == 'ar'">
                  نحن صادقون ، منفتحون ويعملون بروح ونص القانون.
                </p>
              </section>
            </aside>
          </article>
          <!-- #endregion -->

          <!-- #region About Dedication -->
          <article [ngClass]="lang" id="Dedication" class="item col-12 wow fadeInUp" data-wow-delay="0.15s">
            <aside class="col-3">
              <img src="../../../../assets/images/Services/Consulting.svg" alt="Dedication" (load)="onLoading('Consulting4')">
              <div id="Consulting4" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </aside>

            <aside class="col-12">
              <h3 *ngIf="lang == 'en'" class="col-12">Dedication</h3>
              <h3 *ngIf="lang == 'ar'" class="col-12">التفاني</h3>

              <section class="text-justify">
                <p *ngIf="lang == 'en'">
                  We are dedicated to being the best in all we do and powering
                  our customers businesses to a higher level.
                </p>
                <p *ngIf="lang == 'ar'">
                  نحن حريصون على أن نكون الأفضل في كل ما نقوم به ونقود أعمال
                  عملائنا إلى مستوى أعلى.
                </p>
              </section>
            </aside>
          </article>
          <!-- #endregion -->

          <!-- #region About Creativity  -->
          <article [ngClass]="lang" id="Creativity " class="item col-12 wow fadeInUp" data-wow-delay="0.15s">
            <aside class="col-3">
              <img src="../../../../assets/images/Services/Consulting.svg" alt="Creativity " (load)="onLoading('Consulting5')">
              <div id="Consulting5" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </aside>

            <aside class="col-12">
              <h3 *ngIf="lang == 'en'" class="col-12">Creativity</h3>
              <h3 *ngIf="lang == 'ar'" class="col-12">الإبداع</h3>

              <section class="text-justify">
                <p *ngIf="lang == 'en'">
                  We constantly strive to think creatively and provide fitting
                  solutions.
                </p>
                <p *ngIf="lang == 'ar'">
                  نحن نسعى باستمرار للتفكير الإبداعي وتقديم حلول مناسبة.
                </p>
              </section>
            </aside>
          </article>
          <!-- #endregion -->

          <!-- #region About Excellence -->
          <article [ngClass]="lang" id="Excellence" class="item col-12 wow fadeInUp" data-wow-delay="0.15s">
            <aside class="col-3">
              <img src="../../../../assets/images/Services/Consulting.svg" alt="Excellence" (load)="onLoading('Consulting6')">
              <div id="Consulting6" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </aside>

            <aside class="col-12">
              <h3 *ngIf="lang == 'en'" class="col-12">Excellence</h3>
              <h3 *ngIf="lang == 'ar'" class="col-12">التفوق</h3>

              <section class="text-justify">
                <p *ngIf="lang == 'en'">
                  Credentials and Certificates of completion of projects in the local market.
                </p>
                <p *ngIf="lang == 'ar'">
                  نعمل على أعلى المعايير ونسعى جاهدين لتجاوز التوقعات والعائد
                  على الاستثمار.
                </p>
              </section>
            </aside>
          </article>
          <!-- #endregion -->

          <!-- #region About Expertise -->
          <article [ngClass]="lang" id="Expertise" class="item col-12 wow fadeInUp" data-wow-delay="0.15s">
            <aside class="col-3">
              <img src="../../../../assets/images/Services/Consulting.svg" alt="Expertise" (load)="onLoading('Consulting7')">
              <div id="Consulting7" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </aside>

            <aside class="col-12">
              <h3 *ngIf="lang == 'en'" class="col-12">Expertise</h3>
              <h3 *ngIf="lang == 'ar'" class="col-12">الخبرة</h3>

              <section class="text-justify">
                <p *ngIf="lang == 'en'">
                  Strong industry credentials and customer references to deliver
                  specialized solutions.
                </p>
                <p *ngIf="lang == 'ar'">
                  أوراق اعتماد و شهادات انجاز مشاريع في السوق المحلية.
                </p>
              </section>
            </aside>
          </article>
          <!-- #endregion -->

          <!-- #region About Commitment -->
          <article [ngClass]="lang" id="Commitment" class="item col-12 wow fadeInUp" data-wow-delay="0.15s">
            <aside class="col-3">
              <img src="../../../../assets/images/Services/Consulting.svg" alt="Commitment" (load)="onLoading('Consulting8')">
              <div id="Consulting8" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </aside>

            <aside class="col-12">
              <h3 *ngIf="lang == 'en'" class="col-12">Commitment</h3>
              <h3 *ngIf="lang == 'ar'" class="col-12">الإلتزام</h3>

              <section class="text-justify">
                <p *ngIf="lang == 'en'">
                  Continued investment in the local market with flexibility in
                  delivery.
                </p>
                <p *ngIf="lang == 'ar'">
                  استمرار الاستثمار في السوق المحلية بمرونة في التسليم.
                </p>
              </section>
            </aside>
          </article>
          <!-- #endregion -->
        </div>
      </div>

      <div class="col-md-5 col-sm-12 m-auto p-5 hide d-none d-md-block">
        <img src="../../../../assets/images/items/about.svg" alt="Service" class=" wow fadeInUp" data-wow-delay="0s" (load)="onLoading('Service')">
        <div id="Service" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- #endregion -->

<!-- #region About Partiner -->
<section [ngClass]="lang" class="partiner col-12 wow fadeInUp p-5" data-wow-delay="0.15s">
  <div class="continer text-center">
    <h3 *ngIf="lang == 'en'" class="col-12">Our Partners</h3>
    <h3 *ngIf="lang == 'ar'" class="col-12">شركاؤنا</h3>

    <app-partnier></app-partnier>
  </div>
</section>
<!-- #endregion -->

<!-- #region Contact Us -->
<app-contactus></app-contactus>
<!-- #endregion -->

<!-- #region footer -->
<app-footer></app-footer>
<!-- #endregion -->
